<template>
  <AppRow>
    <EducationSelect v-if="hasEducation" v-model="occupation.education" />
    <OccupationStatus v-model="occupation.status" />
  </AppRow>
  <v-expand-transition>
    <div v-if="detailsVisible" class="mt-4">
      <FormHeading :h="5">
        {{ $tt('business_details') }}
      </FormHeading>
      <AppRow sequence-two>
        <TextField v-model="occupation.name" :label="$tt('business_name')" :rules="[required]" />
        <SenioritySelect v-if="hasSeniority" v-model="occupation.seniority" />
        <PhoneField v-if="hasPhone" v-model="occupation.phone" :rules="[required]" />
      </AppRow>
      <AddressFields
        v-if="hasAddress"
        v-model="occupation.address"
        :label="$tt('business_address')"
        class="mt-3"
      />
    </div>
  </v-expand-transition>
</template>

<script setup lang="ts">
import type { Occupation, OccupationStatus } from '~/types';

const occupation = defineModel<Occupation>({ required: true });
const props = defineProps<{
  hasPastJob?: boolean;
  hasPhone?: boolean;
  hasAddress?: boolean;
  hasSeniority?: boolean;
  hasEducation?: boolean;
  hideDetails?: boolean;
}>();

const ACTIVE_STATUSES: OccupationStatus[] = ['employee', 'self_employed'];
const working = computed(() => ACTIVE_STATUSES.includes(occupation.value.status));
const worked = computed(() => working.value || occupation.value.status == 'retired');

const detailsVisible = computed(() => {
  if (props.hideDetails) return false;
  return props.hasPastJob ? worked.value : working.value;
});

const { required } = useValidation();
</script>